/* eslint-disable react-hooks/rules-of-hooks */
import { Alert, Upload, Typography, Modal, Row, Col, Button, DatePicker, Form, Card, Input, Select, Space, Switch, Image, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import AddTuitionForm from './AddTuitionForm';
const { TextArea } = Input;
const { RangePicker } = DatePicker;
const AddTuitionModal = ({
    defaultValue,
    select_mode = false,
    ...props
}) => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();
    useEffect(() => {
        form.resetFields()
        form.setFieldsValue({ ...defaultValue })
    }, [defaultValue])
    const postBillPaymentGradeClass = (data) => {
        console.log(data)
        // axios
        //     .post('/cramSchool/api/bill_payment_grade_class', data)
        //     .then((response) => {
        //         let bill_payment_grade_class_id = response.data.bill_payment_grade_class_id
        //         if (bill_payment_grade_class_id) {
        //             navigate(`/cramSchool/admin/AdminStudentTuition/${bill_payment_grade_class_id}`)
        //         }
        //         else {
        //             messageApi.open({
        //                 type: 'error',
        //                 content: '新增失敗',
        //             });
        //             props.setOpen(false)
        //         }
        //     })
    }
    const onCancel = () => {
        props.setOpen(false)
        form.resetFields()
        form.setFieldsValue({ ...defaultValue })
    }
    return (
        <>
            {contextHolder}
            <Modal
                // width={'auto'}
                style={{ pointerEvents: 'auto' }}
                open={props.open}
                onOk={props.handleOk}
                bodyStyle={{ backgroundColor: '##FCF5F6' }}
                width={900}
                footer={false}
                modalRender={(e) => <>
                    <div style={{ backgroundColor: '#FCF5F6', padding: '20px', borderTop: `solid #${props.color} 5px ` }}>
                        <Col span={24}>
                            <span style={{ fontWeight: 'bold', fontSize: '24px', }} >建立班級繳費項目</span>
                        </Col>
                        <Col span={24}>
                            <AddTuitionForm
                                select_mode={select_mode}
                                defaultValue={defaultValue}
                                open={props.open}
                                setOpen={props.setOpen}
                                propsForm={form}
                                onFormFinish={(values) => {
                                    postBillPaymentGradeClass(values)
                                }}
                            />
                        </Col>
                        <Col span={24}>
                            <Row gutter={[10, 10]} justify={"center"}>
                                <Col>
                                    <Button size='large' style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={(e) => (onCancel())} block>取消</Button>
                                </Col>
                                <Col >
                                    <Button onClick={e => {
                                        form.submit()
                                    }} size='large' style={{ background: props.edit ? `#${props.color}` : 'rgba(232, 79, 117, 1)', color: '#ffffff' }} block>{props.edit ? '修改' : '送出'}</Button>
                                </Col>
                            </Row>
                        </Col>
                    </div >
                </>}
                centered
            />
        </>)
}
export default AddTuitionModal;